/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const  getBaseSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro();
  filtro.perPage = 1;
  filtro.filters.addFilter(campo,valor,condicao);
  return filtro
};


export const PlanoSCH = (perPage)=> {
    var filtro = new Filtro();
    filtro.perPage = perPage;
    // filtro.fields = ['*'];
    filtro.fields = ['descricao','nome','valor', 'tp_internet','bloqueado','vl_instalacao','abreviado','planos.cidade_id'];
    filtro.join.addLeft('cidades','cidades.cidade_id','planos.cidade_id')

  return filtro

};
